const nameData = "Articulos_combo"; // Define la entidad dinámica
const nameDataSingular = "Combo"; // Para el caso singular
export const fetchEntityData = async (
  getEntityPanelData,
  idCombo,
  numPagina,
  filas,
  setListaItems,
  setTotalItems,
  arrayCombo
) => {
  
  try {
    let listaCombo = [];
    let totalItems = 0;
    let pagination = {};

    if (idCombo) {
      const data = await getEntityPanelData(idCombo)
      if (data) {
        listaCombo = data.Articulos_combo || [];
        pagination = data.Articulos_combo.length || {};
        totalItems = pagination || 0;
        // Sumar elementos de arrayCombo al total
        totalItems += arrayCombo.length;
        
        // Fusionar listaCombo con arrayCombo
        if (arrayCombo.length > 0) {
          listaCombo = [...listaCombo, ...arrayCombo];
        }

        // Actualiza el estado con los nuevos datos
        setListaItems(listaCombo);

        // Obtener último ID de la lista combinada
        const ultimoElemento = listaCombo[listaCombo.length - 1];
        const ultimoId = ultimoElemento?.id ?? null;

        // Calcular el total de páginas basado en los items totales combinados
        const totalPages = Math.ceil(totalItems / filas);

        return {
          dataEntity: listaCombo,
          totalItems,
          totalPages, // Devolvemos las páginas calculadas
        };
      }
    } else {
      // Si no hay `aofid`, usar solo los datos locales de arrayCombo
      totalItems = arrayCombo.length;

      // Aplicar la paginación en arrayCombo
      const start = (numPagina - 1) * filas;
      const end = start + filas;
      const paginatedarrayCombo = arrayCombo.slice(start, end);

      // Actualizar el estado con los elementos de arrayCombo
      setListaItems(paginatedarrayCombo);
      setTotalItems(totalItems);

      // Calcular el total de páginas considerando arrayCombo
      const totalPages = Math.ceil(totalItems / filas);

      return {
        dataEntity: paginatedarrayCombo,
        totalItems,
        totalPages,
      };
    }
  } catch (error) {
    console.error(`Error al cargar ${nameData}:`, error);
    throw error;
  }
};


// Función de eliminación de elementos
export const deleteItem = async (deleteEntityData, findData,selectedItem,  arrayCombo, removeItem, getOfertaDetByIdData) => {
  try {
    // Verificar si el ID proporcionado está en el array
    const detalleEnArray = arrayCombo.find((item) => item.id === selectedItem);
    
    if (detalleEnArray) {
      // Eliminar directamente del array
      removeItem("combo",selectedItem);
    } else {
      // Si no está en el array, buscar datos desde la API
      const detalle = await findData(selectedItem);
      if (detalle) {
        await deleteEntityData(selectedItem);
      } else {
        console.error(`No se encontraron datos para el ID: ${selectedItem}`);
      }
    }
  } catch (error) {
    console.error("Ocurrió un error durante la eliminación:", error);
    throw error;
  }
};

